<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center mb-5 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Historial de Ventas</h2>
      <p class="text-600 m-0 text-sm mt-1">Ventas manuales entregadas o canceladas. Emite la boleta aquí al completar la venta.</p>
    </div>

    <div class="surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-3">
        <div>
            <span class="text-500 text-xs font-bold uppercase block">Cobrado del periodo</span>
            <span class="text-xl font-bold text-green-700">{{ totalRevenue | currency:'PEN':'symbol' }}</span>
        </div>
        <i class="pi pi-money-bill text-3xl text-green-500"></i>
    </div>
  </div>

  <div class="flex flex-column md:flex-row gap-3 mb-4 justify-content-between">
    <div class="flex gap-2 align-items-center flex-wrap w-full md:w-auto">
        <p-select
            [options]="dateRangeOptions"
            [(ngModel)]="selectedRange"
            (onChange)="onDateRangeChange()"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full md:w-15rem">
        </p-select>
        <p-select
            [options]="estadoFilterOptions"
            [(ngModel)]="selectedEstadoFilterId"
            (onChange)="reloadFirst()"
            optionLabel="label"
            optionValue="value"
            placeholder="Estado"
            styleClass="w-full md:w-12rem">
        </p-select>
        <p-select
            [options]="origenVentaFilterOptions"
            [(ngModel)]="origenVentaFilterId"
            (onChange)="reloadFirst()"
            optionLabel="label"
            optionValue="value"
            placeholder="Origen de venta"
            styleClass="w-full md:w-12rem">
        </p-select>
    </div>

    <div class="flex gap-2 align-items-center flex-wrap w-full md:w-auto">
        <p-iconfield iconPosition="left" class="w-full md:w-auto">
            <p-inputicon styleClass="pi pi-search" />
            <input
                pInputText
                type="text"
                [(ngModel)]="search"
                (input)="scheduleServerLoad()"
                placeholder="Buscar..."
                class="w-full md:w-15rem" />
        </p-iconfield>

        <button pButton icon="pi pi-file-excel" class="p-button-success"
                pTooltip="Excel: Ventas + Detalle productos"
                [loading]="exporting === 'excel'"
                [disabled]="exporting !== null || totalRecords === 0"
                (click)="exportExcel()"></button>
        <button pButton icon="pi pi-file-pdf" class="p-button-danger" pTooltip="Exportar PDF"
                [loading]="exporting === 'pdf'"
                [disabled]="exporting !== null || totalRecords === 0"
                (click)="exportPdf()"></button>
    </div>
  </div>

  <div class="flex gap-3 align-items-center flex-wrap mb-3" *ngIf="selectedOrders.length">
    <span class="text-sm text-600">{{ selectedOrders.length }} pedido(s) seleccionado(s)</span>
    <button pButton label="Aplicar estado a seleccionados" icon="pi pi-check-square" class="p-button-outlined border-round-lg"
      (click)="openBulkStatusDialog()"></button>
  </div>

  <p-table
    #dt
    [value]="filteredOrders"
    [lazy]="true"
    (onLazyLoad)="loadOrders($event)"
    [first]="first"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    dataKey="id"
    [(selection)]="selectedOrders"
    [selectionMode]="'multiple'"
    [tableStyle]="{ 'min-width': '60rem' }"
    [loading]="loading"
    styleClass="p-datatable-sm">

    <ng-template pTemplate="header">
      <tr class="bg-gray-50 text-800">
        <th style="width: 40px">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th style="width: 6%">N° Orden</th>
        <th style="width: 10%">Fecha registro</th>
        <th style="width: 10%">Fecha entrega</th>
        <th style="width: 18%">Cliente</th>
        <th style="width: 12%">Entrega</th>
        <th style="width: 14%">Producto</th>
        <th style="width: 8%">Cant. ítems</th>
        <th style="width: 12%">Estado Final</th>
        <th style="width: 10%">Boleta</th>
        <th style="width: 10%">Total</th>
        <th style="width: 12%" class="text-center">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="transition-colors hover:surface-50">
        <td>
          <p-tableCheckbox [value]="order"></p-tableCheckbox>
        </td>
        <td class="font-bold text-900">#{{ order.id }}</td>
        <td class="text-sm text-600">{{ order.createdAt | peruDate:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <div class="flex flex-column">
            <span class="font-medium text-900">{{ order.scheduledDate | peruDate:'dd/MM/yyyy' }}</span>
            <span class="text-xs text-500">{{ order.scheduledTime }}</span>
          </div>
        </td>
        <td>
          <div class="flex flex-column">
            <span class="font-bold text-900">{{ order.clientName }}</span>
            <span class="text-sm text-600"><i class="pi pi-phone text-xs mr-1"></i>{{ order.clientPhone }}</span>
          </div>
        </td>
        <td>
          <span class="text-sm">{{ order.tipoEnvio?.nombreTipoEnvio || order.deliveryMethod || '-' }}</span>
        </td>
        <td class="text-sm">{{ getOrderProductLabel(order) }}</td>
        <td class="text-center font-medium">{{ getOrderItemsCount(order) }}</td>
        <td>
          <div class="flex flex-wrap gap-1" *ngIf="order.estados?.length">
            <span *ngFor="let e of order.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
          </div>
          <p-tag *ngIf="!order.estados?.length" [value]="order.status" [severity]="getSeverity(order.status)"></p-tag>
        </td>
        <td>
          <ng-container *ngIf="esVentaManualEntregada(order); else boletaNoAplica">
            <p-tag *ngIf="tieneBoleta(order.id)" value="Emitida" severity="success" [rounded]="true"></p-tag>
            <p-tag *ngIf="!tieneBoleta(order.id)" value="Sin boleta" severity="warn" [rounded]="true"></p-tag>
            <div class="flex gap-1 mt-1 flex-wrap">
              <button *ngIf="!tieneBoleta(order.id)" pButton label="Emitir" icon="pi pi-file"
                class="p-button-outlined p-button-sm p-button-secondary"
                [disabled]="!puedeEmitirBoleta(order)"
                [loading]="emittingBoletaOrderId === order.id"
                [pTooltip]="mensajeEmitirBoleta(order)"
                tooltipPosition="top"
                (click)="emitirBoleta(order)"></button>
              <button *ngIf="tieneBoleta(order.id)" pButton icon="pi pi-download"
                class="p-button-text p-button-sm"
                pTooltip="Descargar PDF"
                (click)="descargarBoleta(order.id)"></button>
            </div>
            <button *ngIf="!tieneBoleta(order.id) && isPagoCompleto(order) && !tieneDocumentoCliente(order)"
                    type="button"
                    class="dni-chip"
                    pTooltip="Recomendado para la boleta"
                    tooltipPosition="top"
                    (click)="openDniDialog(order)">
              <i class="pi pi-id-card"></i>
              <span>Registrar DNI/CE</span>
            </button>
            <small *ngIf="boletaStatusMap[order.id]?.numeroCompleto" class="text-500 block mt-1">{{ boletaStatusMap[order.id].numeroCompleto }}</small>
          </ng-container>
          <ng-template #boletaNoAplica>
            <span class="text-500 text-sm">—</span>
          </ng-template>
        </td>
        <td class="font-bold text-900">{{ order.totalAmount | currency:'PEN':'symbol' }}</td>
        <td class="text-center">
          <button pButton icon="pi pi-eye" class="p-button-text p-button-rounded text-600 mr-1" pTooltip="Ver Detalle" (click)="openViewDialog(order)"></button>
          <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded text-600" pTooltip="Cambiar estado" (click)="openStatusDialog(order)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12" class="text-center py-6 text-500">
          <i class="pi pi-filter text-4xl mb-3 block"></i>
          No hay registros en este rango de fechas.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Resumen del Pedido" [(visible)]="viewDialogVisible" [modal]="true"
          [breakpoints]="{'960px': '95vw', '640px': '100vw'}" [style]="{width: '500px'}"
          [draggable]="false" [resizable]="false" styleClass="p-fluid">

  <div *ngIf="selectedOrderForView as order" class="p-1">

    <div class="flex justify-content-between align-items-start mb-4 border-bottom-1 border-gray-100 pb-3">
      <div>
        <span class="text-2xl font-bold block text-900">Pedido #{{order.id}}</span>
        <span class="text-sm text-500 mt-1 block">
          <i class="pi pi-calendar text-xs mr-1"></i>
          {{order.scheduledDate | peruDate:'dd MMM yyyy'}} • {{order.scheduledTime}}
        </span>
      </div>
      <div class="flex flex-wrap gap-1" *ngIf="order.estados?.length">
        <span *ngFor="let e of order.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
      </div>
      <p-tag *ngIf="!order.estados?.length" [value]="order.status" [severity]="getSeverity(order.status)" [rounded]="true"></p-tag>
    </div>

    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="text-xs font-bold text-500 uppercase mb-1">Cliente</div>
        <div class="flex align-items-start gap-1 w-full">
          <span class="min-w-0 font-bold text-900 text-base" style="width: fit-content; max-width: calc(100% - 2.75rem); word-break: break-word; overflow-wrap: anywhere;">{{ order.clientName }}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 align-self-start w-2rem h-2rem" pTooltip="Copiar nombre" (click)="copyToClipboard(order.clientName || '')"></button>
        </div>
        <div class="text-sm text-600 mt-1 flex align-items-center gap-1 w-full">
          <span class="min-w-0 inline-flex align-items-center gap-1" style="width: fit-content; max-width: calc(100% - 2.75rem);"><i class="pi pi-whatsapp flex-shrink-0 text-green-500"></i>{{ order.clientPhone }}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 w-2rem h-2rem" pTooltip="Copiar número" (click)="copyToClipboard(order.clientPhone || '')"></button>
        </div>
        <a *ngIf="order.clientPhone" [href]="getWhatsAppLink(order.clientPhone)" target="_blank" rel="noopener noreferrer"
           pButton label="WhatsApp" icon="pi pi-whatsapp" class="p-button-outlined p-button-sm p-button-info mt-2"></a>
        <div class="mt-2" *ngIf="order.saleOrigin">
          <span class="bg-blue-50 text-blue-700 border-1 border-blue-200 px-2 py-1 border-round text-xs font-bold flex align-items-center w-max">
            <i class="pi pi-shopping-bag mr-1 text-xs"></i> {{ order.saleOrigin }}
          </span>
        </div>
      </div>
      <div class="col-12 md:col-6 border-left-0 md:border-left-1 border-gray-200 pl-0 md:pl-3 mt-3 md:mt-0">
        <div class="text-xs font-bold text-500 uppercase mb-1">Entrega</div>
        <div class="font-bold text-900 text-base">{{ order.tipoEnvio?.nombreTipoEnvio || order.deliveryMethod || '—' }}</div>
        <div class="text-sm font-bold text-800 mt-1" *ngIf="order.distrito?.nombre || order.district">{{ order.distrito?.nombre || order.district }}</div>
        <div class="text-sm text-600 mt-1 flex align-items-start gap-1 w-full" *ngIf="order.deliveryAddress">
          <span class="min-w-0" style="width: fit-content; max-width: calc(100% - 2.75rem); word-break: break-word; overflow-wrap: anywhere;">{{ order.deliveryAddress }}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 align-self-start w-2rem h-2rem" pTooltip="Copiar dirección" (click)="copyToClipboard(getFullAddress(order))"></button>
        </div>
        <div class="flex flex-wrap gap-1 mt-2" *ngIf="order.estados?.length">
          <span *ngFor="let e of order.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
        </div>
        <p-tag *ngIf="!order.estados?.length && order.status" [value]="order.status" [severity]="getSeverity(order.status)" [rounded]="true" styleClass="mt-2"></p-tag>
      </div>

      <div class="col-12 mt-3" *ngIf="order.notes">
        <div class="bg-yellow-50 p-3 border-round border-1 border-yellow-100 text-sm text-yellow-900">
          <span class="font-bold block mb-1">Nota interna:</span>
          "{{order.notes}}"
        </div>
      </div>
    </div>

    <div class="font-bold mt-4 mb-2 text-900">Productos</div>

    <div class="flex flex-column gap-2">
      <div *ngFor="let item of order.items" class="flex align-items-center gap-3 p-3 border-round border-1 border-gray-200 bg-gray-50">
        <div class="flex-1">
          <div class="font-bold text-900 text-base mb-1">
            {{ item.product?.productName || item.product?.name || item.productName || 'Producto' }}
          </div>
          <div class="flex flex-wrap gap-2 text-sm">
             <span class="bg-white border-1 border-gray-300 px-2 border-round text-xs font-bold py-1">
                 Talla: {{item.size}}
             </span>
            <span class="font-bold text-900 ml-1 flex align-items-center">{{item.quantity}} und.</span>
          </div>
        </div>
        <div class="font-bold text-900 text-lg">
          {{ (item.subTotal > 0 ? item.subTotal : ((item.unitPrice || item.product?.price || 0) * item.quantity)) | currency:'PEN':'symbol' }}
        </div>
      </div>
    </div>

    <div class="divider my-3 border-top-1 border-gray-200"></div>

    <div class="flex flex-column gap-2">
      <div class="flex justify-content-between text-sm text-600">
        <span>Subtotal Prendas</span>
        <span class="font-bold text-900">{{ calculateItemsSubtotal(order) | currency:'PEN':'symbol' }}</span>
      </div>

      <div *ngIf="(order.discountAmount ?? 0) > 0" class="flex justify-content-between text-sm text-red-500 font-bold">
        <span>Descuento</span>
        <span>- {{ order.discountAmount | currency:'PEN':'symbol' }}</span>
      </div>

      <div class="flex justify-content-between text-sm text-500 italic">
        <span>Envío (informativo)</span>
        <span>{{ (order.deliveryPrice ?? 0) | currency:'PEN':'symbol' }}</span>
      </div>

      <div class="flex justify-content-between align-items-center mt-2 pt-2 border-top-1 border-gray-200">
        <span class="text-lg font-bold text-900">Total Final</span>
        <span class="text-2xl font-bold text-900">{{ order.totalAmount | currency:'PEN':'symbol' }}</span>
      </div>
    </div>

    <div class="mt-4">
      <div *ngIf="order.status === 'ENTREGADO'"
           class="bg-green-100 p-3 border-round-lg border-1 border-green-300 flex justify-content-between align-items-center">
        <div class="flex align-items-center text-green-800">
          <i class="pi pi-verified mr-2 text-2xl"></i>
          <div class="flex flex-column">
            <span class="font-bold">VENTA COMPLETADA</span>
            <span class="text-xs">El stock ha sido descontado correctamente.</span>
          </div>
        </div>
      </div>

      <div *ngIf="order.status === 'CANCELADO'"
           class="bg-red-50 p-3 border-round-lg border-1 border-red-200 text-center text-red-700">
        <i class="pi pi-times-circle mr-2"></i> <strong>PEDIDO ANULADO</strong>
        <p class="text-xs m-0 mt-1">Este pedido no suma a los ingresos del periodo.</p>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Cerrar" class="p-button-success w-full" (click)="viewDialogVisible=false"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="isBulkStatus ? 'Actualizar Estado (varios pedidos)' : 'Cambiar estado'" [(visible)]="statusDialogVisible" [modal]="true"
          [breakpoints]="{'960px': '95vw'}" [style]="{width: '400px'}"
          [draggable]="false" [resizable]="false" styleClass="p-fluid">
  <div class="flex flex-column gap-3 pt-2">
    <div class="text-center p-3 border-round-xl bg-gray-50 border-1 border-gray-100" *ngIf="selectedOrderForStatus && !isBulkStatus">
      <span class="font-bold block text-2xl text-900 mb-1">#{{ selectedOrderForStatus.id }}</span>
      <span class="text-sm text-600">{{ selectedOrderForStatus.clientName }}</span>
    </div>
    <div class="text-center p-3 border-round-xl bg-gray-50 border-1 border-gray-100" *ngIf="isBulkStatus && selectedOrders.length">
      <span class="font-bold block text-2xl text-900 mb-1">{{ selectedOrders.length }} pedido(s)</span>
      <span class="text-sm text-600">Aplicar estados a los pedidos seleccionados</span>
    </div>
    <div class="field">
      <label class="font-bold mb-2 block text-sm text-700">Estados (selección múltiple)</label>
      <p-multiSelect [options]="estadoOptions" [(ngModel)]="selectedEstadoIds" optionLabel="nombreEstado" optionValue="id"
        placeholder="Seleccionar estados" styleClass="w-full border-round-lg" appendTo="body"
        [filter]="true" filterPlaceHolder="Buscar..."></p-multiSelect>
    </div>
    <p class="text-xs text-500 m-0">Una venta puede tener más de un estado asignado.</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <button pButton label="Cancelar" class="p-button-text text-600" (click)="statusDialogVisible=false; isBulkStatus=false"></button>
      <button pButton label="Confirmar" icon="pi pi-check" class="p-button-black border-round-lg" (click)="saveStatus()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="emitWithoutDniDialog"
          [modal]="true"
          [breakpoints]="{'640px': '95vw'}"
          [style]="{width: '440px'}"
          [draggable]="false"
          styleClass="p-fluid dni-dialog"
          [showHeader]="false">
  <div class="dni-dialog-body" *ngIf="emitWithoutDniOrder">
    <div class="dni-dialog-icon dni-dialog-icon-warn">
      <i class="pi pi-exclamation-triangle"></i>
    </div>
    <h3 class="dni-dialog-title">Emitir sin DNI/CE</h3>
    <p class="dni-dialog-sub">
      Vas a emitir la boleta de
      <strong>{{ emitWithoutDniOrder.clientName }}</strong>
      (pedido #{{ emitWithoutDniOrder.id }})
      <strong>sin documento del cliente</strong>.
      En el PDF el campo de documento quedará vacío.
    </p>
    <div class="dni-dialog-actions dni-dialog-actions-stack">
      <button pButton label="Cancelar e introducir DNI" icon="pi pi-id-card"
              class="p-button-outlined p-button-secondary border-round-3xl"
              (click)="cancelarEmitirEIntroducirDni()"></button>
      <button pButton label="Emitir sin DNI" icon="pi pi-check"
              class="p-button-black border-round-3xl"
              (click)="confirmarEmitirSinDni()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="dniDialog"
          [modal]="true"
          [breakpoints]="{'640px': '95vw'}"
          [style]="{width: '440px'}"
          [draggable]="false"
          styleClass="p-fluid dni-dialog"
          [showHeader]="false">
  <div class="dni-dialog-body" *ngIf="dniOrder">
    <div class="dni-dialog-icon">
      <i class="pi pi-id-card"></i>
    </div>
    <h3 class="dni-dialog-title">Registrar documento</h3>
    <p class="dni-dialog-sub">
      Para emitir la boleta de
      <strong>{{ dniOrder.clientName }}</strong>
      (pedido #{{ dniOrder.id }})
    </p>

    <label class="dni-dialog-label" for="dniInputField">DNI o CE</label>
    <input id="dniInputField"
           pInputText
           class="dni-dialog-input"
           [(ngModel)]="dniInput"
           maxlength="12"
           placeholder="Ej. 12345678"
           (keyup.enter)="guardarDniPedido()" />
    <small class="dni-dialog-hint">DNI: 8 dígitos · CE: 8 a 12 caracteres</small>
    <small class="p-error block mt-1" *ngIf="dniSubmitted && !dniInput.trim()">Documento requerido.</small>
    <small class="p-error block mt-1" *ngIf="dniSubmitted && dniInput.trim() && !esDocumentoValido(dniInput.trim())">
      Formato inválido.
    </small>

    <div class="dni-dialog-actions">
      <button pButton label="Cancelar" class="p-button-text text-600"
              (click)="dniDialog = false" [disabled]="savingDni"></button>
      <button pButton label="Guardar y continuar" icon="pi pi-check"
              class="p-button-black border-round-3xl"
              (click)="guardarDniPedido()" [loading]="savingDni"></button>
    </div>
  </div>
</p-dialog>